const DEFAULT_FALLBACK = "—";

export const fallback = (value: any, fallbackValue = DEFAULT_FALLBACK) => {
  if (value === "") return fallbackValue;
  return value ?? fallbackValue;
};
